import template from './group-detail.html';
import controller from './group-detail.controller';

let groupDetailComponent = {
  bindings: {},
  template,
  controller
};

export default groupDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/group/group-detail.component.js